import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { I18nProvider } from '../_vtsl/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from '../_vtsl/layout/core';
import { MasterInit } from '../_vtsl/layout/MasterInit';
import { AuthInit } from './modules/auth';
import { Provider } from 'react-redux';
import store from './store';




const App = () => {
    return (<Suspense fallback={<LayoutSplashScreen />}>
   
      <I18nProvider>
      <Provider store={store}>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
        </Provider>
      </I18nProvider>

    </Suspense>);
};
export { App };
